import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from "../api.js";

export const GetAccountManagementSlice = createAsyncThunk("admin/Account-viewadmin",async (id, { rejectWithValue }) => {
    try {
      const response = await api.viewadminAccountApi(id);
      console.log("response:",response);
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);  
      }
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

export const ChangePasswordSlice = createAsyncThunk("admin/Change-password",async (data, { rejectWithValue }) => {
    try {
      const response = await api.UpdatePasswordAccountApi(data);
      console.log("response:",response);
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);  
      }
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

export const UpdateProfileSlice = createAsyncThunk("admin/addDetails",async ({id,data}, { rejectWithValue }) => {
    try {
      const response = await api.UpdateDetailsAccountApi({id,data});
      console.log("response:",response);
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);  
      }
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

const AccountManagementSlice = createSlice({
  name: 'AccountManagement',
  initialState: {
    AccountDetails: [],
    AccountUpdate:[],
    UpdateDetails:[],
    UpdatePassword:[],
    loading: false,
    error: null,
    validationErrors: [],
  },
  reducers: {},
  extraReducers: (builder) => {

    const handlePendingState = (state,action) => {
      state.loading = true;
      state.error = null; 
      state.validationErrors = []; 
    }
    const handleRejectState = (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || "An error occurred";
      state.validationErrors = action.payload?.errors || []; 
      // toast.error(state.error);
    }

    builder
      .addCase(GetAccountManagementSlice.pending,handlePendingState)
      .addCase(GetAccountManagementSlice.fulfilled, (state, action) => {
        console.log("action",action)
        state.AccountDetails = action.payload.data; 
        state.loading = false;
        // toast.success(action?.payload?.message); 
      })
      .addCase(GetAccountManagementSlice.rejected,handleRejectState)

      .addCase(ChangePasswordSlice.pending,handlePendingState)
      .addCase(ChangePasswordSlice.fulfilled, (state, action) => {
        console.log("action",action)
        state.AccountUpdate = action.payload.data; 
        state.loading = false;
        // toast.success(action?.payload?.message); 
      })
      .addCase(ChangePasswordSlice.rejected,handleRejectState)

      .addCase(UpdateProfileSlice.pending,handlePendingState)
      .addCase(UpdateProfileSlice.fulfilled, (state, action) => {
        console.log("action",action)
        state.UpdateDetails = action.payload.data; 
        state.loading = false;
        // toast.success(action?.payload?.message); 
      })
      .addCase(UpdateProfileSlice.rejected,handleRejectState)
}, 
});


export default AccountManagementSlice.reducer;
